import React from 'react';
import { Form, Input, Modal, Spin } from 'antd';
import { MoyenPaiement } from 'app/shared/model/facture.model';
import { useAppSelector } from 'app/config/store';

interface GenericActionModalProps {
  visible: boolean;
  onCancel: () => void;
  handleModalOk: (values: {
    name: string;
    amount: number;
    fees: number;
    totalAmount: number;
    phoneNumber: string;
    type: MoyenPaiement;
  }) => Promise<void>;
  confirmLoading: boolean;
  initialValues: { name: string; amount: number; fees: number; totalAmount: number; phoneNumber: string; type: MoyenPaiement | string };
}
const GenericActionModal: React.FC<GenericActionModalProps> = ({ visible, onCancel, confirmLoading, handleModalOk, initialValues }) => {
  const paymentLoading = useAppSelector(state => state.payment.loading);

  const [form] = Form.useForm();
  const getImageSrc = type => {
    switch (type) {
      case MoyenPaiement.WAVE:
        return 'content/images/wave.png';
      case MoyenPaiement.OM:
        return 'content/images/om.png';
      default:
        return 'content/images/logo_korischool.png';
    }
  };

  const onFinish = (values: {
    name: string;
    amount: number;
    fees: number;
    totalAmount: number;
    phoneNumber: string;
    type: MoyenPaiement;
  }) => {
    handleModalOk(values);
  };

  return (
    <>
      <FullscreenBackdrop isShown={paymentLoading} />
      <Modal
        title={
          <div className="modal-image">
            {initialValues.type && (
              <img
                src={getImageSrc(initialValues.type)}
                alt="Payment Method Image"
                style={{ width: '102%', height: '200px', borderRadius: '8px' }}
              />
            )}
          </div>
        }
        visible={visible}
        onCancel={onCancel}
        onOk={form.submit}
        confirmLoading={paymentLoading}
        okText="Confirmer"
        cancelText="Annuler"
        destroyOnClose={true}
      >
        <Spin spinning={paymentLoading} tip="Envoi en Cours...">
          <Form form={form} onFinish={onFinish} initialValues={initialValues}>
            <Form.Item label="Nom" name="name" rules={[{ required: true, message: 'Veuillez saisir un nom.' }]}>
              <Input disabled />
            </Form.Item>
            <Form.Item label="Montant" name="amount" rules={[{ required: true, message: 'Veuillez saisir un montant.' }]}>
              <Input type="number" disabled />
            </Form.Item>
            <Form.Item label="Frais" name="fees" rules={[{ required: true, message: 'Veuillez saisir des frais.' }]}>
              <Input type="number" disabled />
            </Form.Item>
            <Form.Item label="Montant Total" name="totalAmount" rules={[{ required: true, message: 'Veuillez saisir un montant total.' }]}>
              <Input type="number" disabled />
            </Form.Item>
            <Form.Item
              label="Numéro de téléphone"
              name="phoneNumber"
              rules={[{ required: true, message: 'Veuillez saisir un numéro de téléphone.' }]}
            >
              <Input type="tel" />
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default GenericActionModal;

interface FullscreenBackdropProps {
  isShown: boolean;
}

const FullscreenBackdrop: React.FC<FullscreenBackdropProps> = ({ isShown }) => {
  return <>{isShown && <div className="fullscreen-backdrop">{/* Add content or styling as needed */}</div>}</>;
};
